import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { usePromotion } from '@/helpers/composables/usePromotion';
import { useAdServer } from '@/features/ad-server/composables/useAdServer';
import { AdServerCreativeType } from '@/features/ad-server/types';

import { type Offer } from '@/@types/graphql-types';
import type { SnowplowContext } from '@/helpers/tracking/providers';
import type { TitleDetail } from '@/interfaces/title-details-graphql';
import type { TitleOfferFragment } from '@/features/buybox/graphql/fragments/Offer.fragment';
import { OfferLocation } from '@/helpers/offer-helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'AdServerPromotionPlacement',
  props: {
    offers: null,
    title: null,
    additionalContexts: null,
    trackingContexts: null,
    seasonNumber: null,
    episodeNumber: null
  },
  emits: ["clickOut"],
  setup(__props: any) {

const props = __props as {
	offers: Offer[];
	title: TitleDetail;
	additionalContexts: SnowplowContext[];
	trackingContexts: SnowplowContext[];
	seasonNumber?: number | null;
	episodeNumber?: number | null;
};

const ListPromotionRow = () => import('@/features/buybox/components/list/ListPromotionRow.vue');
const QualityTV = () => import('@/features/buybox/components/list/QualityTV.vue');
const SingleQTV = () => import('@/features/buybox/components/list/SingleQTV.vue');





const { adServerCreative } = useAdServer(() => props.title.id);

const adServerCreativeType = computed(() => adServerCreative.value?.__typename ?? null);

const { catalogueItem } = usePromotion({
	title: () => props.title,
	offers: () => props.offers,
	hardcodedShortName: computed(() => null),
});

const qtvAdditionalContexts = computed(() => props.additionalContexts.concat(props.trackingContexts));

return { __sfc: true,ListPromotionRow, QualityTV, SingleQTV, props, adServerCreative, adServerCreativeType, catalogueItem, qtvAdditionalContexts, AdServerCreativeType }
}

})